module.exports = __webpack_public_path__ + "static/media/FATF-Digital-Identity.734b64f3.pdf";